import { SCol, SRow } from '@avalara/skylab-sdk/react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { selectState } from '../../../selectors';
import BillingSummary from './billing-summary';
import CamPanel from './cam-panel';
import DatesToRemember from './dates-to-remember';

const Wrapper = styled.div`
  margin: 50px 0;
`;

const BottomContent = () => {
  const {
    account: { camOwned, cam },
  } = useSelector(selectState);

  const camPanel = !!camOwned && !!cam && (
    <CamPanel name={cam.name} email={cam.email} phone={cam.phone} photoUrl={cam.photoUrl} />
  );

  return (
    <Wrapper>
      <SRow className='justify-content-center'>
        <SCol span='md-12 lg-4 xl-3 4'>
          <DatesToRemember />
        </SCol>
        <SCol span='md-12 lg-2 xl-2 2'>
          <BillingSummary />
        </SCol>
        {camPanel && <SCol span='md-12 lg-2 2'>{camPanel}</SCol>}
      </SRow>
    </Wrapper>
  );
};

export default BottomContent;
